// Analytics utility functions for tracking user interactions
// Using Google Analytics ID: G-NTTXB993DF

/**
 * Track a page view in Google Analytics
 * @param {string} path - The page path to track
 * @param {string} title - The page title
 */
export const trackPageView = (path, title) => {
  if (window.gtag) {
    window.gtag('config', 'G-NTTXB993DF', {
      page_path: path,
      page_title: title
    });
  }
};

/**
 * Track a user interaction/event in Google Analytics
 * @param {string} category - Event category (e.g., 'Recipe', 'Timer', 'Ingredients')
 * @param {string} action - User action (e.g., 'click', 'start', 'complete')
 * @param {string} label - Event label for additional context
 * @param {number} value - Numeric value (optional)
 */
export const trackEvent = (category, action, label, value) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

/**
 * Track recipe step start
 * @param {number} stepId - The ID of the step
 * @param {string} stepName - The name of the step
 */
export const trackStepStart = (stepId, stepName) => {
  trackEvent('Recipe', 'step_start', `Step ${stepId}: ${stepName}`);
};

/**
 * Track recipe step complete
 * @param {number} stepId - The ID of the step
 * @param {string} stepName - The name of the step
 */
export const trackStepComplete = (stepId, stepName) => {
  trackEvent('Recipe', 'step_complete', `Step ${stepId}: ${stepName}`);
};

/**
 * Track quantity change
 * @param {number} newQuantity - The new quantity selected
 */
export const trackQuantityChange = (newQuantity) => {
  trackEvent('Ingredients', 'quantity_change', 'Pav quantity', newQuantity);
};